import { Stack } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Formik } from 'formik';
import React from 'react';
import * as yup from 'yup';
import SubjectUtil from '../../utils/SubjectUtil';
import CancelButton from '../button/CancelButton';
import SubmitButton from '../button/SubmitButton';
import TextField from '../formik/TextField';

const validationSchema = yup.object({
  name: yup.string().required('Naam is verplicht'),
  abbreviation: yup.string().required('Afkorting is verplicht'),
});

const CreateEditSubjectDialog = ({ open, onClose, subject }) => {
  const handleSubmit = (values, { setSubmitting }) => {
    const promise = subject
      ? SubjectUtil.updateSubject(subject.id, { id: subject.id, ...values })
      : SubjectUtil.createSubject(values);
    promise
      .then(response => {
        onClose(response.data);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <Formik
      initialValues={{
        name: subject?.name || '',
        abbreviation: subject?.abbreviation || '',
      }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ handleSubmit, isSubmitting, isValid }) => (
        <Dialog open={open} fullWidth maxWidth="xs">
          <DialogTitle>Vak {subject ? 'bewerken' : 'aanmaken'}</DialogTitle>
          <DialogContent>
            <Stack spacing={2}>
              <TextField name="name" label="Naam*" />
              <TextField name="abbreviation" label="Afkorting*" />
            </Stack>
          </DialogContent>
          <DialogActions>
            <CancelButton onClick={() => onClose()} disabled={isSubmitting} />
            <SubmitButton disabled={isSubmitting || !isValid} onClick={handleSubmit}>
              Opslaan
              {isSubmitting && <CircularProgress size={14} sx={{ ml: 1 }} />}
            </SubmitButton>
          </DialogActions>
        </Dialog>
      )}
    </Formik>
  );
};

export default CreateEditSubjectDialog;
